// Footer.jsx
import React, { useState } from "react";
import "./Footer.css";
import logo1 from "../../assets/logo1.png";
import { FaEnvelope } from "react-icons/fa";
import { FaFacebookF, FaInstagram, FaTiktok, FaXTwitter } from "react-icons/fa6";

import pciDssBadge from "../../assets/pcidsscompliance-rmbg.png";
import Modal from "../Modal/Modal";
import pciImageModal from "../../assets/pcl CERTIFICATE OF COMPLIANCE- Okiri Mobile (Mar 2025)[1].png";

function Footer() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);

  const openModal = (type) => {
    if (type !== "pci") return;

    setModalOpen(true);
    setModalTitle("PCI DSS Compliance");
    setModalContent(
      <div style={{ textAlign: "center" }}>
        <img
          src={pciImageModal}
          alt="PCI DSS Compliance"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </div>
    );
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalContent(null);
  };

  return (
    <>
      <footer className="footer" id="footer">
        <div className="footer__container">
          <div className="footer__columns">
            {/* First Column */}
            <div className="footer__column footer__brand">
              <img src={logo1} alt="OKIRI Logo" className="footer__logo" />

              <p className="footer__text">
                Transform Your Communication
                <br /> Experience with OKIRI
              </p>

              <p className="footer__address">
                23, COLLEGE ROAD , OGBA, IKEJA,
                <br />
                LAGOS STATE, NIGERIA.
                <span className="footer__addressSub">
                  UNDER SUPERVISION PARTNER JERRY-BERRY LLC USA.
                </span>
              </p>

              <a
                className="footer__contact"
                href="mailto:enquiries@okirimobile.com"
              >
                <FaEnvelope className="footer__icon" />
                <span>ENQUIRIES@OKIRIMOBILE.COM</span>
              </a>
            </div>

            {/* Second Column */}
            <div className="footer__column">
              <h4>App</h4>
              <ul>
                <li>
                  <a href="#features" className="footer__link">
                    Features
                  </a>
                </li>
                <li>
                  <a href="#faqs" className="footer__link">
                    FAQs
                  </a>
                </li>
                <li>
                  <a href="#pricing" className="footer__link">
                    Rate
                  </a>
                </li>
              </ul>
            </div>

            {/* Third Column (ONLY Social icons live here now) */}
            <div className="footer__column">
              <h4>Socials</h4>

              <ul className="footer__socialList">
                <li>
                  <a
                    className="footer__socialLink"
                    href="https://www.facebook.com/share/176NiNsP73/?mibextid=wwXIfr"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                  >
                    <span className="footer__socialBadge" aria-hidden="true">
                      <FaFacebookF />
                    </span>
                    <span>Facebook</span>
                  </a>
                </li>

                <li>
                  <a
                    className="footer__socialLink"
                    href="https://x.com/OkiriMobile?t=eZYG3enj_QOd5rITDwUAAw&s=09"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="X (Twitter)"
                  >
                    <span className="footer__socialBadge" aria-hidden="true">
                      <FaXTwitter />
                    </span>
                    <span>X (Twitter)</span>
                  </a>
                </li>

                <li>
                  <a
                    className="footer__socialLink"
                    href="https://www.instagram.com/okirimobilehq?igsh=a3QxYzVhdHRicjRv"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                  >
                    <span className="footer__socialBadge" aria-hidden="true">
                      <FaInstagram />
                    </span>
                    <span>Instagram</span>
                  </a>
                </li>

                <li>
                  <a
                    className="footer__socialLink"
                    href="https://www.tiktok.com/@okiri.mobile?_t=ZM-8xSboR1rn9C&_r=1"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="TikTok"
                  >
                    <span className="footer__socialBadge" aria-hidden="true">
                      <FaTiktok />
                    </span>
                    <span>TikTok</span>
                  </a>
                </li>
              </ul>

              {/* LinkedIn removed as requested */}
            </div>

            {/* Fourth Column */}
            <div className="footer__column">
              <h4>Legal</h4>
              <ul>
                <li>
                  <a href="/policies/privacy-policy/index.html" className="footer__link" target="_blank" rel="noopener noreferrer">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="/policies/request-deletion/index.html" className="footer__link" target="_blank" rel="noopener noreferrer">
                    Data Usage Policy &amp; Deletion Request
                  </a>
                </li>
                <li>
                  <a href="/policies/refund-policy/index.html" className="footer__link" target="_blank" rel="noopener noreferrer">
                    Refund &amp; Cancellation Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer__bottom">
            <hr />
            <div className="footer__bottomInner">
              <img
                src={pciDssBadge}
                alt="PCI DSS Compliant"
                className="footer__pci-badge"
                style={{ cursor: "pointer" }}
                onClick={() => openModal("pci")}
              />
              <p>2026 OKIRI. All rights reserved.</p>
            </div>
          </div>
        </div>
      </footer>

      <Modal isOpen={modalOpen} onClose={closeModal} title={modalTitle}>
        {modalContent}
      </Modal>
    </>
  );
}

export default Footer;
